
import Vue from "vue";

export default Vue.extend({
  name: "SimpleModal",
  props: {
    visible: Boolean,
    headerText: String
  },
  methods: {
    close() {
      this.$emit("close");
    },
    modalSubmit() {
      this.$emit("submit");
    }
  }
});
